import type { AxiosRequestConfig } from 'axios'
import axios, { AxiosInstance } from 'axios'


export class AxiosService {
    protected axios: AxiosInstance

    constructor(
        config?: AxiosRequestConfig
    ) {
        if (!config) config = {}

        this.axios = axios.create(config)
    }

    protected async apiRequest(config: AxiosRequestConfig, url: string, data?: any) {
        if (!config.headers) config.headers = {}

        config.headers['Content-Type'] = 'application/json'

        return this.axios({
            ...config,
            url,
            data: data,
        }).then((res) => {
            return res.data
        })
    }

    protected async apiRequestHeader(config: AxiosRequestConfig, url: string, headerToRetrieve?: string, data?: any,) {
        if (!config.headers) config.headers = {}

        config.headers['Content-Type'] = 'application/json'

        return this.axios({
            ...config,
            url,
            data: data,
        }).then((res) => {
            if (headerToRetrieve) {
                return res.headers[headerToRetrieve] ?? res.headers[headerToRetrieve.toLowerCase()]
            }

            return res.headers
        })
    }

    public get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
        return this.apiRequest({ ...config, method: 'get' }, url)
    }

    public deleteRequest<T = any>(
        url: string,
        config?: AxiosRequestConfig
    ): Promise<T> {
        return this.apiRequest({ ...config, method: 'delete' }, url)
    }

    public post<T = any>(
        url: string,
        data?: any,
        config?: AxiosRequestConfig
    ): Promise<T> {
        return this.apiRequest({ ...config, method: 'post' }, url, data)
    }

    public put<T = any>(
        url: string,
        data: any,
        config?: AxiosRequestConfig
    ): Promise<T> {
        return this.apiRequest({ ...config, method: 'put' }, url, data)
    }

    public patch<T = any>(
        url: string,
        data: any,
        config?: AxiosRequestConfig
    ): Promise<T> {
        return this.apiRequest({ ...config, method: 'patch' }, url, data)
    }

    public head<T = any>(
        url: string,
        config?: AxiosRequestConfig,
        headerToRetrieve?: string,
        data?: any
    ): Promise<T> {
        return this.apiRequestHeader({ ...config, method: 'head' }, url, headerToRetrieve, data)
    }
}
